import React from 'react';
import { Slideover2 } from '@nalgoo-ui-private/nalgoo-ui';

export default function SalaryDetailSlideover({ open, setOpen, info, jobTitle }) {
	return (
		<Slideover2
			open={open}
			onClose={() => setOpen(false)}
		>
			<Slideover2.Panel>
				<Slideover2.Header>
					{jobTitle}
				</Slideover2.Header>
				<Slideover2.Body padded>
					{info}
				</Slideover2.Body>
			</Slideover2.Panel>
		</Slideover2>
	);
}
